export default function ErrorState({
  message,
  onRetry,
}: {
  message: string
  onRetry?: () => void
}) {
  return (
    <div className="rounded-2xl border border-error bg-bg-secondary px-5 py-4 text-sm text-error">
      <p>{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-2 rounded-full border border-error px-4 py-1.5 text-xs font-semibold text-error hover:bg-error hover:text-white"
        >
          Retry
        </button>
      )}
    </div>
  )
}
